'use client';

import { Button } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div<{ $withTitle?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 13px;
  margin-bottom: ${({ $withTitle }) => ($withTitle ? '33px' : '0')};
`;

export const BtnBox = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  && {
    height: 32px;
    gap: 0;
  }
`;
